import { render, staticRenderFns } from "./AudioToggleButton.vue?vue&type=template&id=2b809a1f&scoped=true&"
import script from "./AudioToggleButton.vue?vue&type=script&lang=js&"
export * from "./AudioToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./AudioToggleButton.vue?vue&type=style&index=0&id=2b809a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b809a1f",
  null
  
)

export default component.exports